module.exports = "https://web-assets.ifttt.com/packs/media/docs/connection-architecture-diagram-ec481bb5.png";